import { keyArgsForPagination, mergeForPagination } from "./modules/utils";

const contactsFeedField = {
  keyArgs: args => {
    if (args?.input) {
      return keyArgsForPagination(args.input);
    }
  },
  merge: (existing = {}, incoming = {}, { readField, args }) => {
    if (args?.input) {
      return mergeForPagination({
        existing,
        incoming,
        readField,
        filters: args.input,
      });
    }
    return incoming;
  },
};

const contactSegmentsFeedField = {
  keyArgs: args => {
    if (args?.input) {
      return keyArgsForPagination(args.input);
    }
  },
  merge: (existing = {}, incoming = {}, { readField, args }) => {
    if (args?.input) {
      return mergeForPagination({
        existing,
        incoming,
        readField,
        filters: args.input,
      });
    }
    return incoming;
  },
};

const checklistItemsFeedField = {
  keyArgs: args => {
    if (args?.input) {
      return keyArgsForPagination(args.input);
    }
  },
  merge: (existing = {}, incoming = {}, { readField, args }) => {
    if (args?.input) {
      return mergeForPagination({
        existing,
        incoming,
        readField,
        filters: args.input,
      });
    }
    return incoming;
  },
};

const AdmissionTypePolicy = {
  AdmissionContactView: {
    fields: {
      contactsFeed: contactsFeedField,
    },
  },
  AdmissionContactSegment: {
    fields: {
      contactsFeed: contactsFeedField,
    },
  },
  AdmissionQuery: {
    fields: {
      contactSegmentsFeed: contactSegmentsFeedField,
      checklistItemsFeed: checklistItemsFeedField,
    },
  },
};

export default AdmissionTypePolicy;
